import { render, staticRenderFns } from "./PriceHistory.vue?vue&type=template&id=234c8c70&"
import script from "./PriceHistory.vue?vue&type=script&lang=js&"
export * from "./PriceHistory.vue?vue&type=script&lang=js&"
import style0 from "./PriceHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PriceHistory.vue"
export default component.exports